import * as React from 'react';
import {
    Col,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
} from 'reactstrap';
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import useDomainsQuery from 'services/domains';

interface IProps {

}
const CreateDomain: React.FC<IProps>= (props) =>  {
    let navigate = useNavigate();
    const onSuccessSubmit = () => {
        toast('Domain created', {
            duration: 2000,
            position: 'top-center',
            icon: '👍🏻',
          });
        setTimeout(() => {
            navigate(-1)
        }, 1000);
    }
    const {
        mutate: mutateDomainsCreate,
        isLoading,
        error
    } = useDomainsQuery.useCreate(onSuccessSubmit);
    React.useEffect(() => {
        if (error) {
            toast.error(error.error as string)
        }
    }, [error])
    const  onSubmit = (data:{}) => {
        mutateDomainsCreate(data)
    };
  
    const { register, handleSubmit, formState: { errors } } = useForm();
    const {ref:urlRef,...url} = register('url', { required: true })
    const {ref:is_activeRef,...is_active} = register('is_active')


    return (
   
    <Card className='mt-3'>
            <Toaster />
            <CardBody>
                <h4 className="header-title">Create Domain</h4>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup row>
                        <Label for="url" sm={3}>
                         URL (the address of a web page.)
                        </Label>
                        <Col sm={5}>
                        <Input id="url"  type="text"  {...url} innerRef={urlRef}   placeholder="Enter url" />
                              {errors.url && <span>This field is required</span>}
                        </Col>
                    </FormGroup>
                    <Col sm={5}>
                        <FormGroup
                                check
                                inline
                                row
                            >
                                <Input type="checkbox" id="is_active"   {...is_active} innerRef={is_activeRef} />
                                <Label check  for='is_active'>
                               is active
                                </Label>
                        </FormGroup>
                      </Col>
                   <Col sm={12} className='mt-3'>
                    <Button color="primary" type="submit">
                        {
                            isLoading ? 'Loading...' : 'Create'
                        }
                    </Button>
                   </Col>
                </Form>
            </CardBody>
        </Card>
      
    )
} 

export default CreateDomain;
